import React from 'react';
import styled from 'styled-components';
import Container from '../../shared/Container';
import FlexContent from '../../shared/FlexContent';
import char2 from '../../../assets/images/char2.svg';
import Heading from '../../shared/Heading';
import Image from '../../shared/Image';

const StyledSteps = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: space-evenly; */
  margin-top: 30px;
  margin-bottom: 50px;

  @media (max-width: 425px) {
    margin-top: 0;
  }
`;

const Step = styled.span`
  background: #a80042;
  padding: 10px 30px;
  border-radius: 24px;
  margin-right: 20px;
  flex: 0 0 auto;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  @media (max-width: 1000px) {
    margin: 20px 0;
  }
  p {
    width: 270px;
    font-size: 20px;
    font-weight: 400;
    font-family: 'Gotham';
    line-height: 1.5;
    @media (max-width: 1000px) {
      font-size: 18px;
    }
  }
  @media (max-width: 425px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    ${Step} {
      margin: 20px 0 10px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
`;
const FlexContentHow = styled(FlexContent)`
  flex-direction: row;
  position: relative;
  @media (max-width: 425px) {
    justify-content: center;
  }
`;
const ImageWhy = styled(Image)`
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: -30px;
  @media (max-width: 1000px) {
    margin-bottom: -5px;
    position: absolute;
    right: -10px;
    min-width: initial;
    width: 300px;
    max-width: initial;
    height: initial;
    img {
      width: 100%;
    }
  }
  @media (max-width: 750px) {
    right: -50px;
    width: 250px;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;
const How = () => (
  <Container>
    <Heading>How does it work?</Heading>
    <FlexContentHow>
      <StyledSteps style={{ alignSelf: 'stretch' }}>
        <Flex>
          <Step>Step 1</Step>
          <p>
            Drop an application at our
            <br /> ZOI lottery box.
          </p>
        </Flex>
        <Flex>
          <Step>Step 2</Step>
          <p>
            Casual interview to get to
            <br /> know you better.
          </p>
        </Flex>
        <Flex>
          <Step>Step 3</Step>
          <p>
            Confirm Booking and be
            <br /> part of ZOI community.
          </p>
        </Flex>
        {/* <Spacer /> */}
      </StyledSteps>
      <ImageWhy>
        <img src={char2} alt="Character" />
      </ImageWhy>
    </FlexContentHow>
  </Container>
);

export default How;
